<template>
  <div class="flex items-center justify-between w-full">
    <p class="text-xs text-gray-700">
      Copyright {{ currentYear }} © {{ brand }}.
      <template v-if="showAgencyLink">
        Site internet réalisé par
        <ULink
          to="https://www.agence-aurion.fr/"
          target="_blank"
          class="text-primary"
          title="Agence web au Mans"
        >
          l’agence web Aurion.
        </ULink>
      </template>
    </p>
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    brand?: string
    showAgencyLink?: boolean
  }>(),
  {
    showAgencyLink: true,
  },
)

const currentYear = new Date().getFullYear()
</script>

<style lang=""></style>
